var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"sortable",on:{"click":_vm.sort}},[_c('div',{staticClass:"table-column"},[_vm._t("default"),_vm._v(" "),(_vm.sortable)?_c('div',{staticClass:"sort-handler"},[_c('div',{staticClass:"sort-asc",class:{
                active:
                    _vm.grid.sortingBy.attr === _vm.attr &&
                    _vm.grid.sortingBy.method === 'asc',
            }}),_vm._v(" "),_c('div',{staticClass:"sort-desc",class:{
                active:
                    _vm.grid.sortingBy.attr === _vm.attr &&
                    _vm.grid.sortingBy.method === 'desc',
            }})]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }